(() => {
  const TERM_KEYS = [
    { key: "60", test: /(60\s*months?)/i },
    { key: "36", test: /(36\s*months?)/i },
    { key: "purchase", test: /\bpurchase\b/i },
  ];

  function getMoneyFormat() {
    return (window.theme && theme.moneyFormat) || "{{amount}}";
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, getMoneyFormat());
    }
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: "GBP" });
  }

  function extractTermKeyFromText(text) {
    if (!text) return null;
    const t = String(text);
    for (const term of TERM_KEYS) {
      if (term.test.test(t)) return term.key;
    }
    return null;
  }

  function getMainSelectedOptionValues() {
    const vs = document.querySelector("variant-selects");
    if (!vs) return [];

    const values = [];

    vs.querySelectorAll("select[name^='options[']").forEach((sel) => {
      if (sel.value) values.push(sel.value);
    });

    vs.querySelectorAll("input[type='radio']:checked").forEach((r) => {
      if (r.value) values.push(r.value);
    });

    return values;
  }

  function getMainSelectedTermKey() {
    const optionValues = getMainSelectedOptionValues();
    for (const v of optionValues) {
      const key = extractTermKeyFromText(v);
      if (key) return key;
    }
    return null;
  }

  function accessoryHasOnlyDefaultVariant(variants) {
    return Array.isArray(variants) && variants.length === 1;
  }

  function findMatchingAccessoryVariant(variants, termKey) {
    if (!termKey || !Array.isArray(variants) || variants.length === 0) return null;
    if (accessoryHasOnlyDefaultVariant(variants)) return null;

    const byTitle = variants.find((v) => extractTermKeyFromText(v.title) === termKey);
    if (byTitle) return byTitle;

    const byOptions = variants.find((v) => (v.options || []).some((opt) => extractTermKeyFromText(opt) === termKey));
    return byOptions || null;
  }

  function syncAccessories() {
    const termKey = getMainSelectedTermKey();
    if (!termKey) return;

    document.querySelectorAll("[data-accessory]").forEach((card) => {
      let variants;
      try {
        variants = JSON.parse(card.getAttribute("data-accessory-variants") || "[]");
      } catch {
        return;
      }

      const match = findMatchingAccessoryVariant(variants, termKey);
      if (!match) return;

      const priceEl = card.querySelector("[data-accessory-price]");
      if (priceEl && typeof match.price === "number") {
        priceEl.textContent = formatMoney(match.price);
      }

      const idInput = card.querySelector("[data-accessory-variant-id]");
      if (idInput) idInput.value = match.id;

      const btn = card.querySelector('button[type="submit"]');
      if (btn) btn.disabled = !match.available;
    });
  }

  function bind() {
    // Run once on load
    syncAccessories();

    // Delegated listeners survive Dawn re-rendering variant-selects
    document.addEventListener("change", (e) => {
      if (e.target.closest("variant-selects")) syncAccessories();
    });

    document.addEventListener("input", (e) => {
      if (e.target.closest("variant-selects")) syncAccessories();
    });

    // Extra safety: if theme emits variant events
    document.addEventListener("variant:change", syncAccessories);
    document.addEventListener("variantChange", syncAccessories);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();